import { ReactNode } from 'react';

interface BaseModalProps {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    children: ReactNode;
    celebration?: boolean;
    footer?: ReactNode;
    maxWidth?: 'sm' | 'md' | 'lg';
}

const BaseModal = ({
    isOpen,
    title,
    onClose,
    children,
    celebration = false,
    footer,
    maxWidth = 'md'
}: BaseModalProps) => {
    if (!isOpen) return null;

    const maxWidthClasses = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg'
    };

    return (
        <div className="fixed inset-0 bg-black/50 dark:bg-black/60 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div
                className={`bg-card dark:bg-card-dark shadow-2xl w-full ${celebration ? "max-w-[540px] overflow-hidden rounded-2xl" : `rounded-3xl ${maxWidthClasses[maxWidth]}`} border border-zinc-200 dark:border-white/20`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="p-6 md:p-8">
                    {celebration && <div className="mb-6 text-center text-5xl" aria-hidden="true">🎉</div>}
                    {/* Header */}
                    <div className={celebration ? "mb-3 text-center" : "flex items-start justify-between mb-6"}>
                        <h2 className="text-2xl font-bold text-zinc-900 dark:text-zinc-50">
                            {title}
                        </h2>
                        {!celebration && <button
                            onClick={onClose}
                            className="flex-none p-2 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 transition"
                            aria-label="Close"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                            </svg>
                        </button>}
                    </div>

                    {/* Content */}
                    {children}
                </div>
                {footer && <div className="bg-gray-100 px-6 py-4 dark:bg-backgroundDarker-dark">{footer}</div>}
            </div>
        </div>
    );
};

export default BaseModal;
